import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import QuestionPreview from "../QuestionPreview";
import NumberTextField from "../NumberTextField";
import NumberInputStepper from "../NumberInputStepper";
import NumberInputSlider from "../NumberInputSlider";
import useStyles from "./styles";
import ErrorIcon from "@mui/icons-material/Error";
import { NUMBER_INPUT_ERR_MSG } from "../../constants";
import noop from "../../../services/noop";
import { useTranslation } from "react-i18next";
import { getTranslation } from "../../../locales";

const { STEPSIZE_ERROR, RANGE_ERROR, VALIDNUM_ERROR } = NUMBER_INPUT_ERR_MSG;

const AnswerNumber = (props) => {
  const { t } = useTranslation("surveyTaker");

  const styles = useStyles(props);
  const [errMsg, setErrMsg] = useState("");
  const [value, setValue] = useState(props.value);

  useEffect(() => {
    if (value === "" || (value <= props.max && value >= props.min)) {
      if (errMsg === RANGE_ERROR) {
        setErrMsg("");
        // if (!props.required || value || value === 0) {
        //   props.removeInvalidQuestion(props.questionId);
        // }
      }
      if ((value || value === 0) && errMsg === VALIDNUM_ERROR) {
        setErrMsg("");
      }
      props.handleChange(value);
    } else {
      if (errMsg === VALIDNUM_ERROR) {
        setErrMsg("");
        props.handleChange(value);
      }
      if (errMsg === RANGE_ERROR) {
        props.handleChange(value);
      }
    }
  }, [value, errMsg]);

  useEffect(() => {
    setValue(props.value);
  }, [props.value]);

  const numberInputProps = {
    min: props.min,
    max: props.max,
    stepSize: props.stepSize,
    value: value,
    currentTheme: props.currentTheme,
    setError: setErrMsg,
    errMsg: errMsg,
    setValue: setValue,
    labels: props.labels,
    questionId: props.questionId,
    // addInvalidQuestion: props.addInvalidQuestion,
    // removeInvalidQuestion: props.removeInvalidQuestion,
  };

  const clearButtonHandler = () => {
    setValue("");
    if (errMsg === STEPSIZE_ERROR) setErrMsg("");
  };

  const ClearButton = (props) => {
    return (
      <div
        className={styles.clearButtonContainer}
        data-testid="number-clear-button"
      >
        <button
          className={styles.clearButton}
          onClick={clearButtonHandler}
          data-testid="clear"
        >
          {getTranslation(props.currentLang, "surveyTaker:clear")}
        </button>
      </div>
    );
  };

  return (
    <div className={styles.questionWrapper}>
      <QuestionPreview
        question={props.question || t("surveyTaker:numberQuestion")}
        required={props.required}
        helperText={props.helperText}
      />
      <div id="number-input" className={styles.answer}>
        {props.interactionType === "text" && (
          <>
            <div className={styles.numberInput}>
              <NumberTextField {...numberInputProps} />
            </div>
            <ClearButton currentLang={props.currentLang} />
          </>
        )}
        {props.interactionType === "stepper" && (
          <div className={styles.flexColumn}>
            <div className={styles.numberInput}>
              <NumberInputStepper {...numberInputProps} />
            </div>
            <ClearButton currentLang={props.currentLang} />
          </div>
        )}
        {props.interactionType === "slider" && (
          <>
            <div className={styles.numberSlider}>
              <NumberInputSlider {...numberInputProps} />
            </div>
            <div className={styles.numberInput}>
              <NumberTextField {...numberInputProps} />
            </div>

            <ClearButton currentLang={props.currentLang} />
          </>
        )}
        <p
          className={
            styles.errorText +
            ` ${
              props.interactionType === "slider" ? styles.sliderErrorText : ""
            }`
          }
        >
          {errMsg && (
            <>
              <ErrorIcon style={{ fontSize: "14px" }} />
              {getTranslation(props.currentLang, errMsg)}
            </>
          )}
        </p>
      </div>
    </div>
  );
};

AnswerNumber.propTypes = {
  question: PropTypes.string.isRequired,
  required: PropTypes.bool.isRequired,
  helperText: PropTypes.string,
  interactionType: PropTypes.string.isRequired,
  min: PropTypes.number.isRequired,
  max: PropTypes.number.isRequired,
  stepSize: PropTypes.number,
  labels: PropTypes.object,
  handleChange: PropTypes.func.isRequired,
  value: PropTypes.any.isRequired,
  // addInvalidQuestion: PropTypes.func.isRequired,
  // removeInvalidQuestion: PropTypes.func.isRequired,
};

AnswerNumber.defaultProps = {
  required: false,
  interactionType: "text",
  min: 0,
  max: 100,
  handleChange: noop,
  value: "",
  // addInvalidQuestion: noop,
  // removeInvalidQuestion: noop,
};

export default AnswerNumber;
